import {
  PlatformFeeSettingsOverrides,
  PlatformFeeSimulationResponse,
  Route,
} from "@repo/common"
import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import { request } from "../api"

const toQueryParams = (
  values: Record<string, number | undefined>,
): Record<string, string> => {
  const params: Record<string, string> = {}
  for (const [key, value] of Object.entries(values)) {
    if (value !== undefined) {
      params[key] = String(value)
    }
  }
  return params
}

const platformFeeQueries = {
  all: () => ["platform-fee"],
  simulation: (overrides: PlatformFeeSettingsOverrides) =>
    queryOptions({
      queryKey: [...platformFeeQueries.all(), "simulation", overrides],
      queryFn: () =>
        request<PlatformFeeSimulationResponse>({
          url: Route.STATS__ADMIN_PLATFORM_FEE_SIMULATION,
          method: "GET",
          params: toQueryParams(overrides),
        }),
      placeholderData: keepPreviousData,
    }),
}

export default platformFeeQueries
